import Queryable from "./Queryable"
import { Result, Result2 } from "./Result"

export default class ObjectFun<T> {
    [x: symbol]: Queryable<T>

    /**
     *
    *  将分组后各个数组聚合成一个对象
    * @param {Object} groupObject 使用groupBys分组后对象
    * @param {Array<String>} aggFileds 需要聚合的的字段
    * @param {Object} gpKeys 分组的key集合,如果没传，则取{groupObject}的key
    **/
    AggreObject(aggFileds: Array<string>, gpKeys?: Array<number> | Array<string>): Queryable<T> {
        const keys = gpKeys || Object.keys(this)
        const temp = new Queryable<T>()
        for (let i = 0; i < keys?.length; i++) {
            temp.Add(this[keys[i]].AggregationItem(aggFileds))
        }
        return temp
    }

    /**
    * 隧道,通过callBack获取值,每slice周期获取一次,此值会在{delay}ms后丢弃
    * @param {*} delay 周期 默认2s
    * @param {*} slice 频率 默认200ms
    * @param {*} callBack 回调,传入所有周期内的值Array[],通过此回调返回值获取新值
    */
    static createDelayFifo(callBack: Result2<Array<any>, number, any>, delay: number = 1000, slice: number = 100): void {
        const len = Math.ceil((delay / slice))
        const fifo = new Array<any>(len)
        let index = 0;

        let startTime = performance.now();
        (function animloop() {
            if ((performance.now() - startTime) >= slice) {
                startTime = performance.now();
                const item = callBack(fifo, index)
                fifo[index] = item
                ++index
                if (index === len) {
                    index = 0
                }
            }
            requestAnimationFrame(animloop);
        })();
    }

    /** 模拟开单 */
    static randomPosion(range: number, acount: number, callBack: (number) => any) {
        const randomAcount = Math.round(Math.random() * acount + 1)                         // 随机开单个数
        const arraySlice = new Array<any>(randomAcount)
        for (let i = 0; i < randomAcount; i++) {
            const index = Math.round(Math.random() * range)                                 // 随机`random`个开单网点
            arraySlice[i] = callBack(index)
        }
        return arraySlice
    }
}
